import React, { useState } from "react";
import * as S from "./styles";

interface IDragDropProps {
	fileInputRef: React.RefObject<HTMLInputElement>;
	children: React.ReactNode;
	onCustomDrop: (event: React.DragEvent<HTMLDivElement>) => void;
}

function KOGDragDropArea({ fileInputRef, children, onCustomDrop }: IDragDropProps) {
	const [isDragging, setIsDragging] = useState(false);

	const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		setIsDragging(false);
		onCustomDrop(event);
	};

	const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		setIsDragging(true);
	};

	const handleDragLeave = () => {
		setIsDragging(false);
	};

	const handleAreaClick = () => {
		if (!fileInputRef?.current) return;
		fileInputRef.current.click();
	};

	return (
		<>
			<S.ContainerArea
				id="id-dragDrop-btn-file"
				onClick={handleAreaClick}
				onDrop={handleDrop}
				onDragOver={handleDragOver}
				onDragLeave={handleDragLeave}
				$isDragging={isDragging}
			>
				{children}
			</S.ContainerArea>
		</>
	);
}

export default KOGDragDropArea;
